/**
 * Perfume Oil Corner — Layer 1 casual copy deterrence (POC v1.1)
 * IMPORTANT: This is not DRM or real prevention of DevTools, source inspection,
 * network downloads, screenshots, or public image URL retrieval.
 * Set ENABLED to false to disable all guards without deleting this asset.
 */
(() => {
  'use strict';

  const ENABLED = true;
  const OPTIONS = {
    blockContextMenu: true,
    blockTextSelection: true,
    blockCopyAndCut: true,
    blockSaveAndSourceShortcuts: true,
    blockDevToolsShortcuts: true, // Best effort only; browser shortcuts may bypass JS.
    blockImageDragging: true,
    discourageMobileImageLongPress: true
  };

  if (!ENABLED || window.__pocLayer1GuardLoaded) return;
  window.__pocLayer1GuardLoaded = true;

  // Inputs, search fields, cart notes, checkout-related forms and editors stay usable.
  const ALLOW_SELECTOR = [
    'input', 'textarea', 'select', '[contenteditable=""]',
    '[contenteditable="true"]', '[role="textbox"]',
    '[data-poc-guard-allow]', '.poc-guard-allow'
  ].join(',');

  const asElement = (node) =>
    node instanceof Element ? node : node && node.parentElement;

  function isAllowed(node) {
    const element = asElement(node);
    return Boolean(element && element.closest(ALLOW_SELECTOR));
  }

  function stop(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
  }

  if (OPTIONS.discourageMobileImageLongPress || OPTIONS.blockImageDragging) {
    const style = document.createElement('style');
    style.id = 'poc-layer1-guard-style';
    style.textContent = `
      img {
        ${OPTIONS.blockImageDragging ? '-webkit-user-drag: none;' : ''}
        ${OPTIONS.discourageMobileImageLongPress ? '-webkit-touch-callout: none;' : ''}
      }
    `;
    (document.head || document.documentElement).appendChild(style);
  }

  if (OPTIONS.blockContextMenu) {
    document.addEventListener('contextmenu', (event) => {
      if (!isAllowed(event.target)) stop(event);
    }, true);
  }

  if (OPTIONS.blockTextSelection) {
    document.addEventListener('selectstart', (event) => {
      if (!isAllowed(event.target)) stop(event);
    }, true);
  }

  if (OPTIONS.blockCopyAndCut) {
    ['copy', 'cut'].forEach((type) => {
      document.addEventListener(type, (event) => {
        if (!isAllowed(event.target) && !isAllowed(document.activeElement)) stop(event);
      }, true);
    });
  }

  if (OPTIONS.blockImageDragging) {
    document.addEventListener('dragstart', (event) => {
      const el = asElement(event.target);
      if (el && el.closest('img') && !isAllowed(el)) stop(event);
    }, true);
  }

  document.addEventListener('keydown', (event) => {
    // Text editing inside forms remains usable, but focused inputs must not
    // bypass source/save/DevTools shortcut restrictions.
    const editAllowed = isAllowed(event.target);

    const key = String(event.key || '').toLowerCase();
    const modifier = event.ctrlKey || event.metaKey;
    const devToolsFunctionKey = event.key === 'F12' || event.code === 'F12';
    const devToolsCtrlCombo = modifier && event.shiftKey && ['i', 'j', 'c', 'k'].includes(key);
    const devToolsMacCombo = event.metaKey && event.altKey && ['i', 'j', 'c'].includes(key);
    const plainCopySaveSource = modifier && !event.altKey && !event.shiftKey && ['c', 'x', 'u', 's'].includes(key);

    if (plainCopySaveSource) {
      if ((['c', 'x'].includes(key) && OPTIONS.blockCopyAndCut && !editAllowed) ||
          (['u', 's'].includes(key) && OPTIONS.blockSaveAndSourceShortcuts)) {
        stop(event);
        return;
      }
    }
    if (OPTIONS.blockDevToolsShortcuts && (devToolsFunctionKey || devToolsCtrlCombo || devToolsMacCombo)) {
      stop(event);
    }
  }, true);
})();
